import styled from 'styled-components';
import ImageComputer from '../../../../assets/images/computer.png';
import ImageSpiderBackground from '../../../../assets/images/spider-background.svg';
import ImageSpiderBackgroundSmall from '../../../../assets/images/spider-background-small.svg';
import { Grid } from '@material-ui/core';

export const InformationContainer = styled.section`
	position: relative;
	overflow-x: hidden;

	${props => props.theme.breakpoints.up('xs')} {
		background-image: linear-gradient(338deg, #ffffff 59%, #eaeaea 75%);
		padding: 8% 8% 15% 8%;
		h2 {
			margin-left: -4px;
		}
	}
	${props => props.theme.breakpoints.up('sm')} {
		background-image: linear-gradient(305deg, #ffffff 28%, #eaeaea 50%);
		padding: 11% 11% 12% 11%;
	}

	p {
		color: #515151;
	}

	.paragraph-dark {
		font-weight: 900;
	}

	h1 {
		margin-bottom: 5%;
	}
`;

export const GridInformationData = styled(Grid)`
	${props => props.theme.breakpoints.up('xs')} {
		padding-top: 20px;
	}
	${props => props.theme.breakpoints.up('sm')} {
		padding-right: 5%;
		padding-top: 0px;
	}
`;

export const Computer = styled.div`
	background-image: url(${ImageComputer});
	background-repeat: no-repeat;
	right: 0;
	top: 0;
	z-index: 1;
	background-size: contain;
	background-position: center;

	${props => props.theme.breakpoints.up('xs')} {
		position: relative;
		width: 100%;
		height: 200px;
	}

	${props => props.theme.breakpoints.up('sm')} {
		position: absolute;
		width: 70%;
		height: 100%;
		right: -120px;
	}
`;
export const ContainerSpider = styled.div`
	position: absolute;

	${props => props.theme.breakpoints.up('xs')} {
		background-image: url(${ImageSpiderBackgroundSmall});
		width: 100%;
		background-size: cover;
		height: 200px;
		background-position: center;
		top: 0;
		left: 0;
	}

	${props => props.theme.breakpoints.up('sm')} {
		background-image: url(${ImageSpiderBackground});
		left: 0;
		position: absolute;
		bottom: 0;
		width: 70%;
		background-position: bottom;
		background-size: cover;
		height: 340px;
		top: unset;
	}
`;
